import React from "react";

export default function SearchPeoples() {
  return (
    <div>
      <h2>Coming Soon</h2>
    </div>
  );
}
